import { loadRemoteModule } from '@angular-architects/module-federation';
import { Location } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { PermissionCheckerService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription, filter } from 'rxjs';
@Component({
    selector: 'modern-theme-header',
    templateUrl: 'modern-theme-header.component.html'
})
export class NxiModernThemeHeaderComponent implements OnDestroy, OnInit, AfterViewInit {

    @Input() hideLogoutButton: boolean = false;
    @Input() hideQuickQuote: boolean = false;
    @Input() hideNavigation: boolean = false;
    @Input() isLoggedIn: boolean = false;
    @Input() showLanguageSwitch: boolean = false;
    @Input() showHeaderActions: boolean = true;
    @Input() logoShouldNavigateAway: boolean = true; // by default logo will navigate to overview/settings/welcome page
    isThemeSelector: boolean = false;
    isPotentialUser: boolean = false;
    ibdName: string;
    isDisclosuresPage: boolean = false;
    isMobileTheme: boolean = false;
    isLoggedInUser: boolean = false;
    isProfileActive: boolean = false
    logoUrl: string = '/nxi/login';

    isTabletTheme: boolean = false;
    currentUrl: any;
    ibdConfigMap: any;
    subs: Subscription;
    subs1: Subscription;
    isEdelEnabled: boolean = false;
     appSettings: any;
    entitledForConatctUs: boolean;
    isOverviewEntitled: boolean;
    isEquipt: boolean = false;
    isUnbluEnabled: boolean = false;
    isUnbluChatEntitled: boolean = false;
    isUnbluVideoEntitled: boolean = false;
    isUnbluCoBrowsingEntitled: boolean = false;
    unbluVisitorScriptEndpoint: string = '';
    unbluJsAPIScriptEndpoint: string = '';
    isEntitledForAccountOpening: boolean = false;
    isNewAccOpenEnabled: boolean = false;
    hideAcctOpening: boolean = false;
    displayModernQuickQuote: boolean = false;
    settingsAndLogoutAriaHasPopup: string;
    settingsandLogoutTooltip: string;
    isWoveAvailableNowPromoPage: boolean = false;
    isWoveAvailableNowPromoNewBranding: boolean = false;
    constructor(
        private router: Router,
        private authorizationService: PermissionCheckerService,
        private location: Location,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-common', 'node_modules/@pershing/nxi-ng-common/lib');
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
        this.appSettings = appSettings;
        this.ibdConfigMap = appSettings.ibdConfigMap;
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.ibdName = parsemap.ibdName;
            this.isLoggedInUser = appSettings.isLoggedIn;
            this.isPotentialUser = appSettings.isPotentialUser;
            this.isEquipt = appSettings.ibdConfigMap.community === 'equipt' ? true : false;
            this.displayModernQuickQuote = parsemap.displayModernQuickQuote
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobileTheme = true;
        } else if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTabletTheme = true;
        }
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[2] === 'disclosure') {
            this.isDisclosuresPage = true;
        }
        if (url.includes('/theme-selector')) {
            this.isThemeSelector = true;
        }
        if (url.includes('wove-available-now-promo')) {
            this.isWoveAvailableNowPromoPage = true;
        }
        this.isWoveAvailableNowPromoNewBranding = appSettings?.ibdConfigMap?.woveAvailableNowPromoNewBranding || false;

        this.entitledForConatctUs = this.authorizationService.isEntitled("CONTACT_BROKERAGE || ABOUT_US || FINANCIAL_ADVISOR || OUTSIDE_LINKS || DOWNLOAD_FORMS")
        this.isOverviewEntitled = this.authorizationService.isEntitled("ACCOUNT_SUMMARY || ACCOUNT_SUMMARY_1")
        this.isUnbluChatEntitled = this.authorizationService.isEntitled("UNBLU_CHAT");
        this.isUnbluVideoEntitled = this.authorizationService.isEntitled("UNBLU_VIDEO_CALL");
        this.isUnbluCoBrowsingEntitled = this.authorizationService.isEntitled("UNBLU_CO_BROWSING");
        this.unbluVisitorScriptEndpoint = this.appSettings?.ibdConfigMap?.UnbluConfig?.visitorScript || '';
        this.unbluJsAPIScriptEndpoint = this.appSettings?.ibdConfigMap?.UnbluConfig?.jsAPIScript || '';
        this.isUnbluEnabled = this.appSettings?.ibdConfigMap?.isUnbluEnabled || false;
        this.isEntitledForAccountOpening = this.authorizationService.isEntitled("ACCOUNT_OPENING");
        this.isNewAccOpenEnabled = this.appSettings.ibdConfigMap?.isNewAccOpenEnabled ?? this.isNewAccOpenEnabled;
        this.hideAcctOpening = this.appSettings.ibdConfigMap?.disableAcctOpenLink ?? this.hideAcctOpening;
    }
    resolveUrlFlags(url) {
        if (url.includes('account-info-entry-nao') || url.includes('account-status-nao') ||
            url.includes('account-types-nao') || url.includes('account-creation-info-nao') ||
            url.includes('account-verid-nao') || url.includes('account-verid-qa-nao') || url.includes('account-new-userid-nao') ||
            url.includes('what-next') || url.includes('account-congrats-nao') || url.includes('add-fundstransfer') ||
            url.includes('digital-advise-splash') || url.includes('digital-advise-mixin') || url.includes('dt-consent') || url.includes('prospectAccount-login')
            || url.includes('dtAccountTransferConfirm') || url.includes('prospectAccounts') || url.includes('account-verid-nao-ng') || url.includes('site-terms-and-conditions')  || url.includes('link-accounts')) {
            this.showHeaderActions = false;
            this.hideQuickQuote = true;
        }
        else{
            this.showHeaderActions = true;
            this.hideQuickQuote = false;
        }
    }
    ngOnInit() {
        this.processModule();
        let url = this.location.path(false);
        this.resolveUrlFlags(url);
        this.isLoggedIn = this.isLoggedInUser;
        if (this.isLoggedIn) {
            let suppressGoPaperless = false;
            if (this.ibdConfigMap && this.ibdConfigMap.suppressGoPaperless) {
                suppressGoPaperless = this.appSettings.ibdConfigMap.suppressGoPaperless;
            }
            // Certain IBDs need ELECTRONIC_NOTIFICATION enabled
            // but should not be shown with GoPaperless and Edelivery Preferences
            if (this.authorizationService.isEntitled('ELECTRONIC_NOTIFICATION') && (!suppressGoPaperless)) {
                this.isEdelEnabled = true;
            }
            if (this.appSettings.isSSOLogoutHide) {
                this.translationService.get('NXI_PORTAL_COMPONENTS.SETTINGS').subscribe(data => this.settingsandLogoutTooltip = data);
            }else{
                this.translationService.get('NXI_PORTAL_COMPONENTS.SETTINGS_AND_LOGOUT').subscribe(data => this.settingsandLogoutTooltip = data);
            }
            if (this.isOverviewEntitled) {
                this.logoUrl = '/nxi/overview';
            } else {
                this.logoUrl = '/nxi/settings/allsettings'
            }
        }
       this.routerEventsSubs();
    }
    async processModule() {
        let cdnUrl = (window as any).pershingAppSettings.elementConfig['nxi-unblu-advisor-app']['url'];
        await loadRemoteModule({
          type: 'module',
          remoteEntry: cdnUrl,
          exposedModule: './MiscellaneousApp',
        }).then(m => console.log(m));
      }
    routerEventsSubs() {
        this.subs = this.router.events.pipe(
            filter(event => event instanceof NavigationStart), // take only when the navigation start
            filter(event => !(event as NavigationStart).url.includes('dummy/refresh')) // ignore dummy/refresh
          ).subscribe((url: any) => {
            // console.log('current url auth' + url.url);
            if (url.url) {
                this.currentUrl = url.url;
            }
            // Treat the duplicate confirmation screen as prelogin screen to hide logout
            // and other components.
            if (this.currentUrl.includes('duplicatesessionconfirmation')) {
                this.isLoggedIn = false;
            }
            this.resolveUrlFlags(this.currentUrl);
            if (this.currentUrl.includes('add-fundstransfer') || this.currentUrl.includes('account-congrats-nao') || this.currentUrl.includes('account-status-nao') || this.currentUrl.includes('welcome')) {
                this.hideQuickQuote = true;
            }
            if (this.currentUrl.includes('/login') || this.currentUrl.includes('/login1') || this.currentUrl.includes('/welcome') || !this.isLoggedIn) {
                this.logoUrl = '/nxi/login';
            }
            this.isWoveAvailableNowPromoPage = this.currentUrl.includes('wove-available-now-promo');
        });
    }
    
    ngAfterViewInit(): void {
        this.settingsAndLogoutAriaHasPopup = 'dialog';
    }

    public ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }
    }
    messageCenter(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/communications/messagecenter',
            }
        }));
    }

    eDeliveryPreferences(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/allsettings/allsettingsSecLevel/edelpreferences',
            }
        }));
    }

    /**
     * Take care the navigation when click on logo
     */
    redirectHome() {
        if (this.logoShouldNavigateAway) {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': this.logoUrl
                }
            }));
        } else {
            let queryParams = new URLSearchParams(window.location.search);
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoParams': queryParams ? Object.fromEntries(queryParams) : {},
                    'gotoPage': window.location.pathname
                }
            }));
        }
    }

    openAnAccount(): void {
        document.dispatchEvent(
          new CustomEvent("portal.gotoview", {
            detail: {
              gotoPage: "/nxi/account-types-nao",
              gotoParams: { fromLogin: true },
            },
          })
        );
    
      }
}
